"use client";

// packages/react/roving-focus/src/roving-focus-group.tsx
import _toConsumableArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["__scopeRovingFocusGroup", "orientation", "loop", "dir", "currentTabStopId", "defaultCurrentTabStopId", "onCurrentTabStopIdChange", "onEntryFocus", "preventScrollOnEntryFocus"],
  _excluded2 = ["__scopeRovingFocusGroup", "focusable", "active", "tabStopId"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { composeEventHandlers } from "@radix-ui/primitive";
import { createCollection } from "@radix-ui/react-collection";
import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { createContextScope } from "@radix-ui/react-context";
import { useId } from "@radix-ui/react-id";
import { Primitive } from "@radix-ui/react-primitive";
import { useCallbackRef } from "@radix-ui/react-use-callback-ref";
import { useControllableState } from "@radix-ui/react-use-controllable-state";
import { useDirection } from "@radix-ui/react-direction";
import { jsx } from "react/jsx-runtime";
var ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var EVENT_OPTIONS = {
  bubbles: false,
  cancelable: true
};
var GROUP_NAME = "RovingFocusGroup";
var _createCollection = createCollection(GROUP_NAME),
  _createCollection2 = _slicedToArray(_createCollection, 3),
  Collection = _createCollection2[0],
  useCollection = _createCollection2[1],
  createCollectionScope = _createCollection2[2];
var _createContextScope = createContextScope(GROUP_NAME, [createCollectionScope]),
  _createContextScope2 = _slicedToArray(_createContextScope, 2),
  createRovingFocusGroupContext = _createContextScope2[0],
  createRovingFocusGroupScope = _createContextScope2[1];
var _createRovingFocusGro = createRovingFocusGroupContext(GROUP_NAME),
  _createRovingFocusGro2 = _slicedToArray(_createRovingFocusGro, 2),
  RovingFocusProvider = _createRovingFocusGro2[0],
  useRovingFocusContext = _createRovingFocusGro2[1];
var RovingFocusGroup = React.forwardRef(function (props, forwardedRef) {
  return /* @__PURE__ */jsx(Collection.Provider, {
    scope: props.__scopeRovingFocusGroup,
    children: /* @__PURE__ */jsx(Collection.Slot, {
      scope: props.__scopeRovingFocusGroup,
      children: /* @__PURE__ */jsx(RovingFocusGroupImpl, _objectSpread(_objectSpread({}, props), {}, {
        ref: forwardedRef
      }))
    })
  });
});
RovingFocusGroup.displayName = GROUP_NAME;
var RovingFocusGroupImpl = React.forwardRef(function (props, forwardedRef) {
  var __scopeRovingFocusGroup = props.__scopeRovingFocusGroup,
    orientation = props.orientation,
    _props$loop = props.loop,
    loop = _props$loop === void 0 ? false : _props$loop,
    dir = props.dir,
    currentTabStopIdProp = props.currentTabStopId,
    defaultCurrentTabStopId = props.defaultCurrentTabStopId,
    onCurrentTabStopIdChange = props.onCurrentTabStopIdChange,
    onEntryFocus = props.onEntryFocus,
    _props$preventScrollO = props.preventScrollOnEntryFocus,
    preventScrollOnEntryFocus = _props$preventScrollO === void 0 ? false : _props$preventScrollO,
    groupProps = _objectWithoutProperties(props, _excluded);
  var ref = React.useRef(null);
  var composedRefs = useComposedRefs(forwardedRef, ref);
  var direction = useDirection(dir);
  var _useControllableState = useControllableState({
      prop: currentTabStopIdProp,
      defaultProp: defaultCurrentTabStopId,
      onChange: onCurrentTabStopIdChange
    }),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    _useControllableState3 = _useControllableState2[0],
    currentTabStopId = _useControllableState3 === void 0 ? null : _useControllableState3,
    setCurrentTabStopId = _useControllableState2[1];
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isTabbingBackOut = _React$useState2[0],
    setIsTabbingBackOut = _React$useState2[1];
  var handleEntryFocus = useCallbackRef(onEntryFocus);
  var getItems = useCollection(__scopeRovingFocusGroup);
  var isClickFocusRef = React.useRef(false);
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    focusableItemsCount = _React$useState4[0],
    setFocusableItemsCount = _React$useState4[1];
  React.useEffect(function () {
    var node = ref.current;
    if (node) {
      node.addEventListener(ENTRY_FOCUS, handleEntryFocus);
      return function () {
        return node.removeEventListener(ENTRY_FOCUS, handleEntryFocus);
      };
    }
  }, [handleEntryFocus]);
  return /* @__PURE__ */jsx(RovingFocusProvider, {
    scope: __scopeRovingFocusGroup,
    orientation: orientation,
    dir: direction,
    loop: loop,
    currentTabStopId: currentTabStopId,
    onItemFocus: React.useCallback(function (tabStopId) {
      return setCurrentTabStopId(tabStopId);
    }, [setCurrentTabStopId]),
    onItemShiftTab: React.useCallback(function () {
      return setIsTabbingBackOut(true);
    }, []),
    onFocusableItemAdd: React.useCallback(function () {
      return setFocusableItemsCount(function (prevCount) {
        return prevCount + 1;
      });
    }, []),
    onFocusableItemRemove: React.useCallback(function () {
      return setFocusableItemsCount(function (prevCount) {
        return prevCount - 1;
      });
    }, []),
    children: /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
      tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
      "data-orientation": orientation
    }, groupProps), {}, {
      ref: composedRefs,
      style: _objectSpread({
        outline: "none"
      }, props.style),
      onMouseDown: composeEventHandlers(props.onMouseDown, function () {
        isClickFocusRef.current = true;
      }),
      onFocus: composeEventHandlers(props.onFocus, function (event) {
        var isKeyboardFocus = !isClickFocusRef.current;
        if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
          var entryFocusEvent = new CustomEvent(ENTRY_FOCUS, EVENT_OPTIONS);
          event.currentTarget.dispatchEvent(entryFocusEvent);
          if (!entryFocusEvent.defaultPrevented) {
            var items = getItems().filter(function (item) {
              return item.focusable;
            });
            var activeItem = items.find(function (item) {
              return item.active;
            });
            var currentItem = items.find(function (item) {
              return item.id === currentTabStopId;
            });
            var candidateItems = [activeItem, currentItem].concat(_toConsumableArray(items)).filter(Boolean);
            var candidateNodes = candidateItems.map(function (item) {
              return item.ref.current;
            });
            focusFirst(candidateNodes, preventScrollOnEntryFocus);
          }
        }
        isClickFocusRef.current = false;
      }),
      onBlur: composeEventHandlers(props.onBlur, function () {
        return setIsTabbingBackOut(false);
      })
    }))
  });
});
var ITEM_NAME = "RovingFocusGroupItem";
var RovingFocusGroupItem = React.forwardRef(function (props, forwardedRef) {
  var __scopeRovingFocusGroup = props.__scopeRovingFocusGroup,
    _props$focusable = props.focusable,
    focusable = _props$focusable === void 0 ? true : _props$focusable,
    _props$active = props.active,
    active = _props$active === void 0 ? false : _props$active,
    tabStopId = props.tabStopId,
    itemProps = _objectWithoutProperties(props, _excluded2);
  var autoId = useId();
  var id = tabStopId || autoId;
  var context = useRovingFocusContext(ITEM_NAME, __scopeRovingFocusGroup);
  var isCurrentTabStop = context.currentTabStopId === id;
  var getItems = useCollection(__scopeRovingFocusGroup);
  var onFocusableItemAdd = context.onFocusableItemAdd,
    onFocusableItemRemove = context.onFocusableItemRemove;
  React.useEffect(function () {
    if (focusable) {
      onFocusableItemAdd();
      return function () {
        return onFocusableItemRemove();
      };
    }
  }, [focusable, onFocusableItemAdd, onFocusableItemRemove]);
  return /* @__PURE__ */jsx(Collection.ItemSlot, {
    scope: __scopeRovingFocusGroup,
    id: id,
    focusable: focusable,
    active: active,
    children: /* @__PURE__ */jsx(Primitive.span, _objectSpread(_objectSpread({
      tabIndex: isCurrentTabStop ? 0 : -1,
      "data-orientation": context.orientation
    }, itemProps), {}, {
      ref: forwardedRef,
      onMouseDown: composeEventHandlers(props.onMouseDown, function (event) {
        if (!focusable) event.preventDefault();else context.onItemFocus(id);
      }),
      onFocus: composeEventHandlers(props.onFocus, function () {
        return context.onItemFocus(id);
      }),
      onKeyDown: composeEventHandlers(props.onKeyDown, function (event) {
        if (event.key === "Tab" && event.shiftKey) {
          context.onItemShiftTab();
          return;
        }
        if (event.target !== event.currentTarget) return;
        var focusIntent = getFocusIntent(event, context.orientation, context.dir);
        if (focusIntent !== void 0) {
          if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
          event.preventDefault();
          var items = getItems().filter(function (item) {
            return item.focusable;
          });
          var candidateNodes = items.map(function (item) {
            return item.ref.current;
          });
          if (focusIntent === "last") candidateNodes.reverse();else if (focusIntent === "prev" || focusIntent === "next") {
            if (focusIntent === "prev") candidateNodes.reverse();
            var currentIndex = candidateNodes.indexOf(event.currentTarget);
            candidateNodes = context.loop ? wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
          }
          setTimeout(function () {
            return focusFirst(candidateNodes);
          });
        }
      })
    }))
  });
});
RovingFocusGroupItem.displayName = ITEM_NAME;
var MAP_KEY_TO_FOCUS_INTENT = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function getDirectionAwareKey(key, dir) {
  if (dir !== "rtl") return key;
  return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function getFocusIntent(event, orientation, dir) {
  var key = getDirectionAwareKey(event.key, dir);
  if (orientation === "vertical" && ["ArrowLeft", "ArrowRight"].includes(key)) return void 0;
  if (orientation === "horizontal" && ["ArrowUp", "ArrowDown"].includes(key)) return void 0;
  return MAP_KEY_TO_FOCUS_INTENT[key];
}
function focusFirst(candidates) {
  var preventScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  var _iterator = _createForOfIteratorHelper(candidates),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var candidate = _step.value;
      if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
      candidate.focus({
        preventScroll: preventScroll
      });
      if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function wrapArray(array, startIndex) {
  return array.map(function (_, index) {
    return array[(startIndex + index) % array.length];
  });
}
var Root = RovingFocusGroup;
var Item = RovingFocusGroupItem;
export { Item, Root, RovingFocusGroup, RovingFocusGroupItem, createRovingFocusGroupScope };